import React from 'react'
import { connect } from 'react-redux'

import { updateFurnitureFilter as updateFurnitureFilterAction } from 'models/furniture/actions'

import CategoryFilters from 'components/designSidepanel/ProductFilter/CategoryFilters'

interface CategoryFiltersContainerProps {
    updateFurnitureFilter: typeof updateFurnitureFilterAction,
}

const CategoryFiltersContainer = ({ updateFurnitureFilter }: CategoryFiltersContainerProps) => (
    <CategoryFilters updateFurnitureFilter={updateFurnitureFilter} />
)

const mapDispatchToProps = {
    updateFurnitureFilter: updateFurnitureFilterAction,
}

export default connect(null, mapDispatchToProps)(CategoryFiltersContainer)
